// extracted by mini-css-extract-plugin
export default {"wrapper":"UserFoto_wrapper__KT3xb","listItem":"UserFoto_listItem__B23FJ","listWrapper":"UserFoto_listWrapper__t5IM7"};